import styled from 'styled-components';
import { colors, mixins, media } from '../css';
import SVGIcon from '../SVGIcon';
import Text from '../BuildingBlocks/Text';

export const StyledProgressItem = styled.span`
  display: inline-block;
  vertical-align: top;
  width: ${props => props.width}%;
  text-align: center;
  padding: ${mixins.pxToRem(16)} 0;
`;

export const StyledSVGIcon = styled(SVGIcon)`
  margin-right: 0.5rem;
  display: inline-block;
`;

export const StyledArrowSVGIcon = styled(SVGIcon)`
  transform: translateY(-50%) rotate(180deg);
  position: absolute;
  top: 50%;
  left: 0;
`;

export const BackSVGIcon = styled(SVGIcon)`
  transform: rotate(180deg);
`;

export const StyledPara = styled(Text.CopyParagraph)`
  position: relative;
  margin: ${mixins.pxToRem(15)} 0;
  display: inline-block;
  font-size: 16px;

  ${media.greaterThan('lg')`
    margin: 0;
  `};
`;

export const StyledBar = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${colors.colorGrey04};
  position: relative;

  &:before {
    content: ' ';
    position: absolute;
    top: -1px;
    left: 0;
    height: 4px;
    background-color: ${colors.colorBlue};
    width: ${props => (props.barWidth > 100 ? 100 : props.barWidth)}%;
  }
`;

export const BackButtonWrapper = styled.div`
  width: 100;
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const StyledBackButton = styled.button`
  cursor: pointer;
  outline: none;
`;

export const StyledMobileContainer = styled.div`
  position: relative;
  text-align: center;
`;

export const StyledHeadingFourth = styled(Text.HeadingFourth)`
  margin: 1rem 0 1.6rem;
`;

export const ProgressBarMasterContainer = styled.div`
  background-color: ${colors.colorWhite};
  width: 100%;
`;
export const ProgressBarContainer = styled.div`
  width: 80%;
`;

export const StyledButton = styled.button`
  outline: none;
  ${props => props.onClick && `cursor: pointer;`};
  ${props => props.disabled && `cursor: default;`};
`;
